// ShipSyncStatusView moved into Views/Ship/SyncStatusView.tsx. This thin re-export barrel
// keeps the original `./ShipSyncStatusView` import path working for external references
// (e.g. AppOverlayContentView.tsx and its test, which mocks this module) outside the Ship hub.

export { ShipSyncStatusView, ShipSyncStatusViewData, ShipSyncStatusMessageView } from "./Ship/SyncStatusView"
